// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--33ssi","labelBadge":"labelBadge--2FS5O","iconBadge":"iconBadge--1V1Vz"};